import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';

const BrandsSection = () => {
  const brands = [
    {
      name: "Trucco",
      tagline: "Diseños sofisticados con inspiración contemporánea",
      description: "Vestidos midi, abrigos elegantes y prendas pensadas para una mujer segura y actual.",
      image: "https://images.unsplash.com/photo-1609941367698-2648ef759ada?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwd29tYW4lMjBmYXNoaW9uJTIwbW9kZWwlMjBvZmZpY2UlMjBzdHlsZSUyMGJsYXplcnxlbnwwfHx8fDE3NzM0MDA3MTJ8MA&ixlib=rb-4.1.0&q=85",
      link: "https://styleoutlet.es/10-trucco",
      bgColor: "bg-[#111111]",
      textColor: "text-white"
    },
    {
      name: "Naelle",
      tagline: "Moda femenina versátil con diseños modernos",
      description: "Perfecta para crear looks elegantes y cómodos para el día a día.",
      image: "https://images.unsplash.com/photo-1704915066475-79cd1c8f4b6c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHx3b21hbiUyMGNhc3VhbCUyMGNoaWMlMjBzdHJlZXQlMjBzdHlsZSUyMGJlaWdlJTIwY29hdHxlbnwwfHx8fDE3NzM0MDA3MTN8MA&ixlib=rb-4.1.0&q=85",
      link: "https://styleoutlet.es/18-naelle",
      bgColor: "bg-[#EDE7E1]",
      textColor: "text-[#111111]"
    }
  ];

  return (
    <section data-testid="brands-section" className="section-padding bg-[#EDE7E1]">
      <div className="container-custom">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-sm font-sans tracking-[0.2em] uppercase text-[#C8A96A] mb-4 block">
            Nuestras Marcas
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#111111]">
            Marcas destacadas
          </h2>
        </div>

        {/* Brands Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {brands.map((brand, index) => (
            <div 
              key={index}
              data-testid={`brand-card-${brand.name.toLowerCase()}`}
              className={`relative overflow-hidden group cursor-pointer ${brand.bgColor}`}
            >
              <div className="grid grid-cols-1 md:grid-cols-2 min-h-[500px]">
                {/* Image */}
                <div className="relative overflow-hidden img-zoom order-2 md:order-1">
                  <img
                    src={brand.image}
                    alt={brand.name}
                    className="w-full h-full object-cover min-h-[300px] md:min-h-full"
                  />
                </div>

                {/* Content */}
                <div className={`flex flex-col justify-center p-8 md:p-12 order-1 md:order-2 ${brand.textColor}`}>
                  <h3 className="font-serif text-4xl md:text-5xl font-bold mb-4">
                    {brand.name}
                  </h3>
                  <p className="font-serif text-lg italic mb-4 opacity-90">
                    {brand.tagline}
                  </p>
                  <p className="font-sans text-base mb-8 opacity-80 leading-relaxed">
                    {brand.description}
                  </p>
                  <a 
                    href={brand.link} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    data-testid={`brand-cta-${brand.name.toLowerCase()}`}
                  >
                    <Button 
                      className={`w-fit ${
                        index === 0 
                          ? 'bg-[#C8A96A] hover:bg-white hover:text-[#111111]' 
                          : 'bg-[#111111] hover:bg-[#C8A96A]'
                      } text-white px-8 py-6 text-sm font-bold tracking-widest uppercase transition-all duration-300 cursor-pointer`}
                    >
                      Ver colección {brand.name}
                      <ArrowRight className="ml-2 w-4 h-4" />
                    </Button>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandsSection;
